import { Gem, HeartHandshake, ShieldCheck } from 'lucide-react'
import PageHero from '../components/PageHero'
import SEO from '../components/SEO'
import { localBusinessSchema } from '../config/schema'
import SectionHeading from '../components/SectionHeading'
import { imageSize } from '../data/images'

const values = [
  { icon: Gem, title: 'Excellence', text: 'We aim for a high standard in the facility, the experience, and the professionals who call it home.' },
  { icon: ShieldCheck, title: 'Integrity', text: 'Clear communication, professional conduct, and respect shape every interaction.' },
  { icon: HeartHandshake, title: 'Guest-Centered Service', text: 'The needs, comfort, and satisfaction of every guest remain at the center of the experience.' },
]

export default function About() {
  return (
    <>
      <SEO page="about" structuredData={localBusinessSchema} />
      <PageHero
        index="02"
        eyebrow="About"
        title="A modern home for Ocala’s beauty community"
        description="Private suites, independent talent, and a shared commitment to an elevated client experience."
        image="community-main.jpg"
        imagePosition="50% 48%"
      />

      <section className="section">
        <div className="container split-grid">
          <div>
            <SectionHeading index="01" eyebrow="Overview" title="The evolution of beauty services in Ocala" />
            <p>
              Diamond Suites Ocala began with a simple idea: independent professionals deserve a polished, functional space where they can create an experience that feels completely their own.
            </p>
            <p>
              The result is a curated beauty and wellness destination where clients can discover several specialties in one convenient building and professionals can grow inside customizable private suites.
            </p>
          </div>
          <div className="image-frame image-frame--portrait">
            <img src={`${import.meta.env.BASE_URL}images/Home-banner-slider.webp`} alt="Diamond Suites Ocala waiting area" {...imageSize('Home-banner-slider.webp')} loading="lazy" />
          </div>
        </div>
      </section>

      <section className="section section--soft">
        <div className="container">
          <SectionHeading index="02" eyebrow="Our vision" title="Independent, not isolated" align="center" />
          <div className="vision-grid">
            <article><span>01</span><h3>Conveniently located</h3><p>Central Ocala access, easy navigation, and generous parking.</p></article>
            <article><span>02</span><h3>Thoughtful amenities</h3><p>Practical support and shared spaces that help each business operate smoothly.</p></article>
            <article><span>03</span><h3>Design-forward spaces</h3><p>A contemporary setting that strengthens the client experience and each provider’s brand.</p></article>
            <article><span>04</span><h3>Community-oriented</h3><p>A network of independent professionals with room to connect, refer, and grow.</p></article>
          </div>
        </div>
      </section>

      <section className="section section--ink">
        <div className="container">
          <SectionHeading index="03" eyebrow="What guides us" title="Empowering beauty professionals" align="center" />
          <div className="values-grid">
            {values.map(({ icon: Icon, title, text }) => (
              <article key={title}>
                <Icon />
                <h3>{title}</h3>
                <p>{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container prose-grid">
          <div>
            <p className="eyebrow">Our commitment</p>
            <h2>Where excellence in beauty comes together</h2>
          </div>
          <div className="long-copy">
            <h3>A curated community of experts</h3>
            <p>
              Each specialist brings their own business, methods, and creative point of view. Together they offer clients a broad range of services without sacrificing the personal attention of a private suite.
            </p>
            <h3>Why we are different</h3>
            <p>
              Rather than operating as one salon brand, Diamond Suites gives independent experts a refined place to build their own. Clients gain variety, privacy, and the convenience of returning to one familiar destination.
            </p>
            <h3>The experience you deserve</h3>
            <p>
              Carefully selected talent, a modern facility, personalized service, and easy access create an environment where clients feel welcomed and professionals can thrive.
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
